import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={73.696}
      height={98.221}
      viewBox="0 0 73.696 98.221"
      {...props}
    >
      <g data-name="light-bulb (2)">
        <path
          data-name="Path 1012"
          d="M29.191 89.101v.027a7.657 7.657 0 1015.314 0v-.027z"
          fill="#165a9f"
        />
        <path
          data-name="Path 1013"
          d="M44.026 89.129H29.67a4.307 4.307 0 010-8.614h14.356a4.307 4.307 0 010 8.614z"
          fill="#003586"
        />
        <path
          data-name="Path 1014"
          d="M35.413 89.128H29.67a4.307 4.307 0 110-8.614h5.743a4.307 4.307 0 000 8.614z"
          fill="#456b93"
        />
        <path
          data-name="Path 1015"
          d="M44.026 80.515H29.67a4.307 4.307 0 010-8.614h14.356a4.307 4.307 0 010 8.614z"
          fill="#003586"
        />
        <path
          data-name="Path 1016"
          d="M35.413 80.514H29.67a4.307 4.307 0 110-8.614h5.743a4.307 4.307 0 000 8.614z"
          fill="#456b93"
        />
        <path
          data-name="Path 1017"
          d="M62.976 37.159A26.128 26.128 0 1020.956 57.9a11.381 11.381 0 014.4 9.043 4.959 4.959 0 004.959 4.959h13.053a4.959 4.959 0 004.959-4.959 11.581 11.581 0 014.525-9.135 26.081 26.081 0 0010.124-20.649z"
          fill="#ffe177"
        />
        <path
          data-name="Path 1018"
          d="M32.559 70.449a4.947 4.947 0 003.5 1.451h-5.743a4.957 4.957 0 01-4.958-4.958 11.379 11.379 0 00-4.4-9.043 26.127 26.127 0 0116.2-46.865c.865.01 1.721.063 2.563.155a26.128 26.128 0 00-13.022 46.71 11.379 11.379 0 014.4 9.043 4.945 4.945 0 001.46 3.507z"
          fill="#ffc85e"
        />
        <g data-name="Group 122">
          <path
            data-name="Path 1019"
            d="M13.024 43.675c-3.875-14.253 6.181-29.257 20.869-31.03a1.436 1.436 0 00-.344-2.851c-16.419 1.982-27.632 18.683-23.3 34.634q.672 1.291 1.762 1.009a1.436 1.436 0 001.013-1.762z"
          />
          <path
            data-name="Path 1020"
            d="M40.146 9.794a1.436 1.436 0 10-.339 2.851A24.691 24.691 0 0151.98 56.669a13.118 13.118 0 00-5.081 10.271c0 2.4-2.292 3.535-4.307 3.522V43.248h3.188a6.03 6.03 0 000-12.059h-.03a6.037 6.037 0 00-6.03 6.03v3.158h-5.74v-3.159a6.037 6.037 0 00-6.03-6.03h-.03a6.03 6.03 0 000 12.059h3.188v27.216c-2.017.014-4.307-1.118-4.307-3.522a12.883 12.883 0 00-4.966-10.182 24.637 24.637 0 01-6.557-7.583 1.436 1.436 0 10-2.508 1.4 27.5 27.5 0 007.317 8.462 10 10 0 013.843 7.9 6.824 6.824 0 002.152 4.783 6.1 6.1 0 00-2.152 4.482 5.729 5.729 0 001.948 4.305 6.129 6.129 0 00-1.948 4.309 5.76 5.76 0 003.9 5.441 9.09 9.09 0 0018.038 0 6.1 6.1 0 003.9-5.441 5.729 5.729 0 00-1.948-4.305 6.124 6.124 0 001.948-4.309 5.734 5.734 0 00-2.158-4.482 6.379 6.379 0 002.158-4.783 10.369 10.369 0 013.97-8A27.563 27.563 0 0040.145 9.792zm2.445 27.425a3.162 3.162 0 013.158-3.158h.031a3.159 3.159 0 010 6.317h-3.188zm-14.674 3.158a3.159 3.159 0 110-6.317h.03a3.162 3.162 0 013.158 3.158v3.158zm6.06 2.871h5.743v27.216h-5.74zm2.871 52.1a6.231 6.231 0 01-6.052-4.786h12.1a6.231 6.231 0 01-6.048 4.786zm7.178-22.013a2.871 2.871 0 110 5.743h-2.073a1.436 1.436 0 100 2.871h2.073a2.875 2.875 0 012.871 2.871 2.972 2.972 0 01-2.871 2.871H29.67a2.871 2.871 0 010-5.743h6.026a1.436 1.436 0 000-2.871H29.67a2.871 2.871 0 110-5.743z"
          />
        </g>
        <path
          data-name="Path 1021"
          d="M36.849 6.891a1.436 1.436 0 01-1.436-1.436V1.436a1.436 1.436 0 112.871 0v4.02a1.436 1.436 0 01-1.435 1.435z"
        />
        <g data-name="Group 123">
          <path
            data-name="Path 1022"
            d="M14.65 16.086a1.431 1.431 0 01-1.015-.42l-2.842-2.842a1.436 1.436 0 012.03-2.03l2.842 2.842a1.436 1.436 0 01-1.015 2.451z"
          />
          <path
            data-name="Path 1023"
            d="M61.887 63.324a1.432 1.432 0 01-1.015-.42l-2.842-2.842a1.436 1.436 0 012.03-2.03l2.842 2.842a1.435 1.435 0 01-1.015 2.451z"
          />
        </g>
        <g data-name="Group 124">
          <path
            data-name="Path 1024"
            d="M5.455 38.284h-4.02a1.436 1.436 0 010-2.871h4.02a1.436 1.436 0 010 2.871z"
          />
          <path
            data-name="Path 1025"
            d="M72.261 38.284h-4.02a1.436 1.436 0 010-2.871h4.02a1.436 1.436 0 010 2.871z"
          />
        </g>
        <g data-name="Group 125">
          <path
            data-name="Path 1026"
            d="M11.808 63.324a1.436 1.436 0 01-1.015-2.451l2.842-2.842a1.436 1.436 0 012.03 2.03l-2.842 2.842a1.431 1.431 0 01-1.015.421z"
          />
          <path
            data-name="Path 1027"
            d="M59.046 16.086a1.436 1.436 0 01-1.015-2.451l2.842-2.842a1.436 1.436 0 012.03 2.03l-2.842 2.842a1.431 1.431 0 01-1.015.421z"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
